import { render, staticRenderFns } from "./create-certificate-btn.vue?vue&type=template&id=20b327b6&scoped=true&"
import script from "./create-certificate-btn.vue?vue&type=script&lang=js&"
export * from "./create-certificate-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b327b6",
  null
  
)

export default component.exports